import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { TargetClients } from './components/TargetClients';
import { WhyChooseUs } from './components/WhyChooseUs';
import { FAQ } from './components/FAQ';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';

export default function HomeIPPage() {
  return (
    <div className="bg-white">
      <Hero />
      <Services />
      <TargetClients />
      <WhyChooseUs />
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
}